<template>
  <div class="selected-tag-wrap">
    <div class="f-list-wrap" v-for="(tag, index) in list" :key="tag.name">
      <div class="label-wrap">
        <span class="label-wrap-logo">
          <img v-if="tag.icon" :src="tag.icon" alt="图标" />
          <div>{{ tag.name }}</div>
        </span>
      </div>
      <div class="tag-list-wrap">
        <div
          ref="spaceWrap"
          size="small"
          align="center"
          class="space-wrap"
          :class="{ showMore: tag.isMore }"
        >
          <div
            class="a-checkable-tag"
            v-for="tagItem in tag.tagList"
            :key="tagItem.value"
            :class="{ tagIsActive: checkSelectedStatus(tag, tagItem) }"
            @click="(checked) => handleChange(tag.name, tagItem, checked, tag)"
          >
            <TagItem
              v-bind="tagItem"
              :ref="tagItem.isCustom ? tag.name : 'TagItem'"
              @sure="
                (result) => handlerCustomInput(tag.name, tagItem, result, tag)
              "
            ></TagItem>
          </div>
        </div>
      </div>
      <span
        v-if="tag.hasMore"
        class="flex-align-center"
        :class="{ moreWrap: tag.hasMore }"
      >
        <a @click="showMore(index, tag)">{{ tag.moreTitle }}</a>
      </span>
    </div>
    <!-- <Loading :loading="loading"></Loading> -->
  </div>
</template>

<script>
// import Loading from '@/components/Loading/'
import TagItem from '../TagItem'
const _ = require('lodash')

export default {
  components: {
    // Loading,
    TagItem
  },
  props: {
    selectedTagList: {
      type: Array,
      default: () => []
    },
    checkableTagList: { // 多选筛选的列表配置
      type: Array,
      default: () => []
    },
    checkableMap: Object
  },
  data() {
    return {
      loading: false,
      selectedTags: [],
      list: [],
      labelMapping: {} // label 2 Instance + parentTag + item实例映射
    }
  },
  watch: {
    selectedTagList(v) {
      console.log(v)
    }
  },
  mounted() {
    this.initSetting() // 初始化配置
  },
  methods: {
    selectSomeOne(labelV, status) {
      const tagInstance = this.labelMapping[labelV]
      if (!tagInstance) return
      const { fatherTag, childTagItem, instance } = tagInstance
      this.handleChange(fatherTag, childTagItem, status, instance)
    },
    checkSelectedStatus(tag, tagItem) {
      return this.checkableMap[tag.name] &&
        !tagItem.isCustom ? this.checkableMap[tag.name].name === tagItem.name : false
    },
    initSetting() {
      this.loading = true
      this.list = this.checkableTagList
      // this.$nextTick(() => {
      //   this.normalizeTagList()
      //   this.initOpt()  // 重置配置
      // })
      this.$nextTick(() => {
        this.normalizeTagList()
      })
      this.initOpt() // 重置配置
      this.loading = false
    },
    // 重置展开提示
    initOpt() {
      this.checkableTagList.forEach(item => {
        this.createLabel2InstanceMapping(item) // 生成以label为准的映射表
        const { spliceIdx, hasMore } = item
        item.isMore = false
        item.moreTitle = '展开'
        if (hasMore && spliceIdx !== -1) {
          item.tagList.splice(spliceIdx) // 重新切割数据超出的部分
        }
      })
    },
    // 生成映射表
    createLabel2InstanceMapping(source) {
      const { name: fatherTag } = source
      source.tagList.reduce((pre, childTagItem) => {
        const { name: label } = childTagItem
        pre[label] = _.cloneDeep({
          fatherTag,
          childTagItem,
          instance: source
        })
        return pre
      }, this.labelMapping)
    },
    normalizeTagList() {
      const refs = this.$refs.spaceWrap // 所有的ref的数组   //bug tag数组被切割后改变，数组为未超出的部分，触发不了spliceIdx赋值条件
      const e = document.getElementsByClassName('tag-list-wrap')
      const boxWidth = e[0].clientWidth // 获取容器的总宽度
      refs.forEach((i, index) => {
        const childrens = [...i.children]
        let spliceIdx = -1 // 超出后的元素下标
        childrens.reduce((total, curVal, index) => {
          const v = total + curVal.clientWidth
          if (v > boxWidth && spliceIdx === -1) { // 超出后取 坐标 - 1 获取上一个未超出的下标（并且确保只能进入一次，idx不能等于-1）
            spliceIdx = index - 1
          }
          return v
        }, 0)
        // 取出当前chackableList对应的对象
        const curTagItem = this.checkableTagList[index] // 获取当前的对象
        curTagItem.spliceIdx = spliceIdx // 记录分界下标
        if (spliceIdx > 0) { // 有下标说明存在超出
          curTagItem.hasMore = true // 显示更多按钮
          curTagItem.moreList = curTagItem.tagList.splice(spliceIdx) // 裁切结果数组
          this.$set(this.list, index, curTagItem) // 动态更新
        }
      })
    },
    showMore(index) {
      const tempItem = this.list[index]
      const {
        moreList, tagList, spliceIdx, isMore
      } = tempItem
      let tempList = []
      if (!isMore) { // 收起状态
        tempList = tempList.concat(tagList, moreList) // 合并
        tempItem.tagList = tempList
      } else { // 展开状态
        tagList.splice(spliceIdx)
      }
      tempItem.isMore = !isMore // 取反当前状态
      tempItem.moreTitle = isMore ? '展开' : '收起'
      this.$set(this.list, index, tempItem)
    },
    // 自定义的输入框结果处理
    handlerCustomInput(fatherTag, childTagItem, result, instance) {
      const { miniV, maxV } = result
      const item = JSON.parse(JSON.stringify(childTagItem))
      item.name = `${item.name}:${miniV}-${maxV}`
      item.value = `${miniV}-${maxV}`
      this.$emit('check-update', { fatherTag, childTagItem: item, checked: true, instance })
    },
    handleChange(fatherTag, childTagItem, checked, instance) {
      if (childTagItem.isCustom) { // 如果是自定义的tag不直接抛出事件

      } else {
        if (this.$refs[fatherTag]) {
          this.$refs[fatherTag].forEach((ref) => ref.initComponentV()) // 执行初始化
        }
        this.$emit('check-update', { fatherTag, childTagItem, checked, instance })
      }
    }
  }
}
</script>
